import React from "react";
import NumberInput from "../../../../common/NumberInput";

const AdjustmentsTab = ({ rateConfig, setRateConfig, disabled }) => {
  const updateAdjustment = (field, value) => {
    setRateConfig((prev) => ({
      ...prev,
      adjustments: {
        ...prev.adjustments,
        [field]: value,
      },
    }));
  };

  const calculateTotalAdjustment = () => {
    return (
      (Number(rateConfig.adjustments.transport) || 0) +
      (Number(rateConfig.adjustments.operational) || 0) +
      (Number(rateConfig.adjustments.rent) || 0)
    ).toFixed(2);
  };

  const calculateFinalRate = (baseRate = 5000) => {
    const totalAdjustments = 
      (Number(rateConfig.adjustments.transport) || 0) +
      (Number(rateConfig.adjustments.operational) || 0) +
      (Number(rateConfig.adjustments.rent) || 0);
    
    const marginMultiplier = 1 + (Number(rateConfig.adjustments.margin) || 0) / 100;
    
    return ((baseRate + totalAdjustments) * marginMultiplier).toFixed(2);
  };

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-semibold mb-3">Location-based Adjustments</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          <AdjustmentInput
            label="Transport Cost (₹/gm)"
            value={rateConfig.adjustments.transport}
            onChange={(value) => updateAdjustment('transport', value)}
            disabled={disabled}
          />
          
          <AdjustmentInput
            label="Operational Cost (₹/gm)"
            value={rateConfig.adjustments.operational}
            onChange={(value) => updateAdjustment('operational', value)}
            disabled={disabled}
          />
          
          <AdjustmentInput
            label="Rent Premium (₹/gm)"
            value={rateConfig.adjustments.rent}
            onChange={(value) => updateAdjustment('rent', value)}
            disabled={disabled}
          />
          
          <AdjustmentInput
            label="Margin Adjustment (%)"
            value={rateConfig.adjustments.margin}
            onChange={(value) => updateAdjustment('margin', value)}
            suffix="%"
            step="0.1"
            disabled={disabled}
          />
        </div>
      </div>

      {/* Total Adjustment Preview */}
      <div className="bg-blue-50 p-4 rounded-lg">
        <h4 className="font-medium mb-2">Total Adjustments</h4>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
          <div>
            <span className="text-gray-600">Base Rate:</span>
            <span className="ml-2 font-medium">₹5,000/gm</span>
          </div>
          <div>
            <span className="text-gray-600">+ Adjustments:</span>
            <span className="ml-2 font-medium">
              ₹{calculateTotalAdjustment()}
            </span>
          </div>
          <div>
            <span className="text-gray-600">+ Margin:</span>
            <span className="ml-2 font-medium">
              {Number(rateConfig.adjustments.margin) || 0}%
            </span>
          </div>
          <div>
            <span className="text-gray-600">Final:</span>
            <span className="ml-2 font-bold">
              ₹{calculateFinalRate()}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

const AdjustmentInput = ({ label, value, onChange, disabled, suffix = "", step = "0.01" }) => (
  <div>
    <label className="block text-sm font-medium text-gray-700 mb-1">
      {label}
    </label>
    <NumberInput
      value={value}
      onChange={onChange}
      prefix={suffix === "%" ? "" : "₹"}
      suffix={suffix}
      step={step}
      placeholder="0"
      disabled={disabled}
    />
  </div>
);

export default AdjustmentsTab;
